import { useEffect } from "react";
import { Link, useParams } from "react-router-dom";
import ReactMarkdown from "react-markdown";
import remarkGfm from "remark-gfm";
import { getPost } from "../data/posts";
import Seo from "./Seo";
import SiteNav from "./SiteNav";

const formatDate = (iso) =>
  new Date(`${iso}T00:00:00`).toLocaleDateString("en-GB", {
    day: "numeric",
    month: "short",
    year: "numeric",
  });

export default function BlogPost() {
  const { slug } = useParams();
  const post = getPost(slug);

  useEffect(() => {
    document.body.classList.add("blog-mode");
    return () => document.body.classList.remove("blog-mode");
  }, []);

  if (!post) {
    return (
      <div className="blog-shell">
        <Seo title="Not found" description="That note is not here." path={`/blog/${slug || ""}`} />
        <SiteNav mode="blog" />
        <main className="blog-article">
          <p className="blog-lead">No post at this URL.</p>
          <Link to="/blog" className="blog-back mono">
            ← All notes
          </Link>
        </main>
      </div>
    );
  }

  return (
    <div className="blog-shell">
      <Seo
        title={post.title}
        description={post.description}
        path={`/blog/${post.slug}`}
        image={post.ogImage}
        type="article"
        published={post.date}
        tags={post.tags}
      />
      <SiteNav mode="blog" />
      <article className="blog-article">
        <div className="grain-overlay" />
        <Link to="/blog" className="blog-back mono">
          ← Field notes
        </Link>
        <header className="blog-article-head">
          <div className="blog-row-meta mono">
            <time dateTime={post.date}>{formatDate(post.date)}</time>
            {post.tags.map((tag) => (
              <span key={tag} className="blog-row-tag">
                {tag}
              </span>
            ))}
          </div>
          <h1 className="grad-text">{post.title}</h1>
          <p className="blog-lead">{post.description}</p>
        </header>
        <div className="blog-prose">
          <ReactMarkdown remarkPlugins={[remarkGfm]}>{post.content}</ReactMarkdown>
        </div>
      </article>
    </div>
  );
}
